import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  fr: {
    originsTitle: "Origines et lignées",
    paternalLineage: "Lignée paternelle",
    maternalLineage: "Lignée maternelle",
    paternalClan: "Famille paternelle (Mvog)",
    personalOrigin: "Origines de la personne",
    origin_village: "Village / localité",
    origin_ethnic_group: "Ethnie / peuple",
    origin_clan: "Clan / famille",
    origin_region: "Région",
    origin_country: "Pays / territoire",
    culturalIdentity: "Identité culturelle déclarée",
    culturalIdentityHint: "Exemple : man Evondo ; man ngon Essambon",
    identityNoInference: "À renseigner selon les témoignages, sans attribution automatique.",
    lineagePriority: "La lignée paternelle est mise en avant pour l’appartenance Evondo. La lignée maternelle est également préservée.",
    originParentHint: "Complétez les origines connues. Les champs laissés vides reprennent les origines renseignées sur la fiche du parent lié, si disponibles.",
    originUnknown: "Origines non renseignées",
    paternalLink: "Lien paternel",
    maternalLink: "Lien maternel",
    showMaternalLinks: "Afficher les liens maternels",
    appName: "Ekom 1",
    tagline: "Mémoire Evondo",
    village: "Village",
    clans: "Clans",
    tree: "Arbre",
    directory: "Annuaire",
    activity: "Activité",
    login: "Se connecter",
    register: "S'inscrire",
    logout: "Déconnexion",
    search: "Rechercher une personne…",
    addPerson: "Ajouter une personne",
    newPerson: "Nouvelle personne",
    editPerson: "Modifier la personne",
    firstName: "Prénom",
    lastName: "Nom de famille",
    nickname: "Surnom",
    gender: "Genre",
    male: "Homme",
    female: "Femme",
    unknown: "Non spécifié",
    clan: "Clan (Mvog)",
    birthYear: "Année de naissance",
    deathYear: "Année de décès",
    birthPlace: "Lieu de naissance",
    biography: "Biographie / histoire orale",
    father: "Père",
    mother: "Mère",
    spouses: "Conjoint(s)",
    children: "Enfants",
    photo: "Photo",
    uploadPhoto: "Téléverser une photo",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    confirmDelete: "Confirmer la suppression ?",
    isAlive: "En vie",
    heroTitle: "Ekom 1 — l'arbre vivant d'un village",
    heroSubtitle: "Reconstituons ensemble la mémoire du village d'Ekom 1, commune de Nkolafamba, à travers les cinq familles Mvog Koé.",
    exploreClans: "Explorer les clans",
    contribute: "Contribuer",
    totalPersons: "Personnes enregistrées",
    contributors: "Contributeurs",
    clansCount: "Familles Mvog Koé",
    aboutTitle: "À propos du projet",
    aboutText: "Ekom 1 est un village du centre du Cameroun, dans la commune de Nkolafamba. Il abrite le peuple Evondo. La particularité du village : toutes les familles sont de la lignée Mvog Koé, réparties en cinq Mvog — Mvog Kombo, Mvog Mbazoa, Mvog Mbengono, Mvog Mbezele Elele et Mvog Efila/Eyamoo Baana. Ce projet collaboratif vise à préserver la mémoire orale et généalogique de notre communauté, génération après génération.",
    members: "membres",
    viewClan: "Voir le clan",
    viewTree: "Voir l'arbre",
    noPersons: "Aucune personne enregistrée pour le moment. Soyez le premier à contribuer.",
    recentActivity: "Activité récente de la communauté",
    created: "a ajouté",
    updated: "a modifié",
    deleted: "a supprimé",
    born: "né·e en",
    died: "décédé·e en",
    details: "Détails",
    close: "Fermer",
    none: "Aucun",
    selectClan: "Choisir un clan",
    allClans: "Tous les clans",
    required: "requis",
    loading: "Chargement…",
    welcomeBack: "Bon retour",
    joinVillage: "Rejoindre le village",
    email: "Email",
    password: "Mot de passe",
    yourName: "Votre nom complet",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Déjà un compte ?",
    signUp: "Créer un compte",
    signIn: "Se connecter",
    toLogin: "Vers la connexion",
    toRegister: "Vers l'inscription",
    treeTitle: "Arbre généalogique du village",
    rootless: "Ancêtres fondateurs",
    emptyTree: "Cet arbre est encore vide. Commencez par ajouter un ancêtre fondateur.",
    patriarch: "Patriarche/Matriarche",
    oralHistory: "Histoire orale",
    deleteSuccess: "Personne supprimée",
    createSuccess: "Personne ajoutée au village",
    updateSuccess: "Informations mises à jour",
    addSpouse: "Ajouter un(e) conjoint(e)",
    removeSpouse: "Retirer",
    noSpouses: "Aucun(e) conjoint(e) lié(e)",
    recordAudio: "Enregistrer l'histoire orale",
    uploadAudio: "Téléverser un audio",
    stopRecording: "Arrêter l'enregistrement",
    recording: "Enregistrement…",
    audioRecordings: "Récits audio",
    audioTitle: "Titre du récit",
    noAudio: "Aucun récit enregistré",
    shareVillage: "Partager le village",
    shareDesc: "Toute votre famille, où qu'elle soit, peut consulter l'arbre à partir de ce lien ou en scannant le QR.",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié ✓",
    suggestEdit: "Suggérer une correction",
    suggestDesc: "Partagez une information manquante ou corrigée. Un contributeur du village la validera.",
    yourMessage: "Votre message / correction",
    yourContact: "Votre contact (optionnel)",
    sendSuggestion: "Envoyer la suggestion",
    suggestionSent: "Merci ! Votre suggestion a été envoyée aux contributeurs.",
    micDenied: "Microphone refusé par le navigateur",
    deleteAudio: "Supprimer ce récit",
    suggestions: "Suggestions",
    openSuggestions: "Suggestions reçues",
    noSuggestions: "Aucune suggestion pour le moment.",
    markResolved: "Marquer comme traité",
    resolved: "Traité",
    verificationStatus: "Statut de l'information",
    proposed: "Proposé",
    verified: "Vérifié",
    disputed: "Contesté",
    to_verify: "À vérifier",
    testimony_confirmed: "Confirmée par témoignage",
    cross_validated: "Validée après recoupement",
    verifyPerson: "Valider cette fiche",
    disputePerson: "Signaler un doute",
    verifiedBy: "Validé par",
    on: "le",
    verificationNotes: "Notes de validation",
    sources: "Sources",
    noSources: "Aucune source attachée. Ajoutez-en une pour tracer l'origine de l'information.",
    addSource: "Ajouter une source",
    sourceType: "Type de source",
    sourceOral: "Témoignage oral",
    sourceDocumentary: "Source documentaire",
    sourcePersonal: "Connaissance personnelle",
    sourceOther: "Autre",
    sourceDescription: "Description / contenu",
    witnessName: "Nom du témoin",
    sourceDate: "Date (optionnel)",
    uploadDocument: "Joindre un document",
    sourceAdded: "Source ajoutée",
    sourceDeleted: "Source supprimée",
    statusChanged: "Statut mis à jour",
    needsReview: "À revalider après modification",
    onlyEldersCanVerify: "Seuls les anciens et administrateurs peuvent valider.",
    adminPanel: "Administration",
    manageMembers: "Gérer les membres",
    role: "Rôle",
    roleContributor: "Contributeur",
    roleElder: "Ancien du village",
    roleAdmin: "Administrateur",
    promote: "Promouvoir",
    filterByStatus: "Statut",
    allStatuses: "Tous les statuts",
    recordedBy: "Noté par",
    editedBackToProposed: "Modifiée — à revalider",
    editAutoDowngrade: "Note : toute modification factuelle par un contributeur ramène le statut à « Proposé » et doit être revalidée par un ancien.",
    chiefs: "Chefs d'Ekom 1",
    chiefsTitle: "Les chefs qui ont régné à Ekom 1",
    chiefsSubtitle: "La mémoire des hommes et des femmes qui ont guidé le village, génération après génération.",
    addChief: "Ajouter un chef",
    editChief: "Modifier le chef",
    chiefName: "Nom du chef",
    reignFrom: "Début de règne",
    reignTo: "Fin de règne",
    chiefBiography: "Récit du règne",
    linkedPerson: "Fiche personne liée (optionnel)",
    noChiefs: "Aucun chef enregistré pour le moment.",
    chiefSaved: "Chef enregistré",
    chiefDeleted: "Chef supprimé",
    reservedToElders: "Rubrique réservée aux anciens et administrateurs",
    present: "présent",
    printClan: "Imprimer / exporter",
    printTitle: "Mémoire de la famille",
    printIntro: "Document généré depuis l'arbre collaboratif Ekom 1.",
    printMembers: "Membres enregistrés",
    printDate: "Document généré le",
    founder: "Patriarche fondateur",
    founderName: "Nom du fondateur",
    founderStory: "Histoire du fondateur",
    editFounder: "Modifier le fondateur",
    noFounderYet: "Fondateur non renseigné. Un ancien peut compléter cette section.",
    chiefsTradition: "Tradition de la chefferie",
    chiefsTraditionDesc: "Comment sont choisis les chefs à Ekom 1 — récit transmis par les anciens.",
    editTradition: "Modifier le récit",
    emptyTradition: "Récit non encore rédigé. Un ancien peut l'ajouter.",
    globalTree: "Arbre Mvog Koé",
    mvogKoeHeader: "Mvog Koé — tronc commun",
    byFamily: "Groupé par famille",
    saved: "Enregistré",
    qrPerson: "QR fiche",
    qrPersonTitle: "Scanner pour ouvrir cette fiche",
    qrPersonDesc: "Les proches peuvent scanner ce code pour accéder directement à cette fiche lors d'une réunion.",
    ancestralLine: "Lignée ancestrale Mvog Koé",
    ancestralLineDesc: "Les ancêtres qui ont précédé Mvog Koé — récit transmis par les anciens.",
    emptyAncestralLine: "Lignée ancestrale non encore rédigée. Un ancien peut la compléter.",
    familyJournal: "Journal de la famille",
    familyJournalDesc: "Chronique vivante tenue par les anciens, mois après mois.",
    noJournal: "Aucune note pour le moment. Un ancien peut en ajouter.",
    addJournalEntry: "Nouvelle note",
    journalMonth: "Mois",
    journalContent: "Note",
    journalSaved: "Note enregistrée",
    journalDeleted: "Note supprimée",
    offlineReady: "Village disponible hors ligne",
    offlineReadyDesc: "Les cinq familles, les fiches et les chefs sont disponibles sans réseau sur cet appareil.",
    installApp: "Installer l'application",
  },
  en: {
    originsTitle: "Origins and lineages",
    paternalLineage: "Paternal lineage",
    maternalLineage: "Maternal lineage",
    paternalClan: "Paternal family (Mvog)",
    personalOrigin: "Personal origins",
    origin_village: "Village / locality",
    origin_ethnic_group: "Ethnic group / people",
    origin_clan: "Clan / family",
    origin_region: "Region",
    origin_country: "Country / territory",
    culturalIdentity: "Declared cultural identity",
    culturalIdentityHint: "Example: man Evondo; man ngon Essambon",
    identityNoInference: "Record according to testimony, without automatic attribution.",
    lineagePriority: "Paternal lineage is emphasized for Evondo affiliation. Maternal lineage is also preserved.",
    originParentHint: "Record known origins. Empty fields use the linked parent’s recorded origins, when available.",
    originUnknown: "Origins not recorded",
    paternalLink: "Paternal link",
    maternalLink: "Maternal link",
    showMaternalLinks: "Show maternal links",
    appName: "Ekom 1",
    tagline: "Evondo Memory",
    village: "Village",
    clans: "Clans",
    tree: "Tree",
    directory: "Directory",
    activity: "Activity",
    login: "Sign in",
    register: "Sign up",
    logout: "Logout",
    search: "Search a person…",
    addPerson: "Add person",
    newPerson: "New person",
    editPerson: "Edit person",
    firstName: "First name",
    lastName: "Last name",
    nickname: "Nickname",
    gender: "Gender",
    male: "Male",
    female: "Female",
    unknown: "Unspecified",
    clan: "Clan (Mvog)",
    birthYear: "Birth year",
    deathYear: "Death year",
    birthPlace: "Birthplace",
    biography: "Biography / oral history",
    father: "Father",
    mother: "Mother",
    spouses: "Spouse(s)",
    children: "Children",
    photo: "Photo",
    uploadPhoto: "Upload photo",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    confirmDelete: "Confirm deletion?",
    isAlive: "Living",
    heroTitle: "Ekom 1 — the living tree of a village",
    heroSubtitle: "Together, let's rebuild the memory of Ekom 1 village, Nkolafamba district, through its five great Evondo families.",
    exploreClans: "Explore clans",
    contribute: "Contribute",
    totalPersons: "Registered persons",
    contributors: "Contributors",
    clansCount: "Familles Mvog Koé",
    aboutTitle: "About this project",
    aboutText: "Ekom 1 is a village in central Cameroon, Nkolafamba district. Its particularity: every family descends from the Mvog Koé lineage, split into five Mvog — Mvog Kombo, Mvog Mbazoa, Mvog Mbengono, Mvog Mbezele Elele and Mvog Efila/Eyamoo Baana. This collaborative project preserves our community's oral and genealogical memory for generations to come.",
    members: "members",
    viewClan: "View clan",
    viewTree: "View tree",
    noPersons: "No person registered yet. Be the first to contribute.",
    recentActivity: "Recent community activity",
    created: "added",
    updated: "edited",
    deleted: "removed",
    born: "born",
    died: "died",
    details: "Details",
    close: "Close",
    none: "None",
    selectClan: "Select a clan",
    allClans: "All clans",
    required: "required",
    loading: "Loading…",
    welcomeBack: "Welcome back",
    joinVillage: "Join the village",
    email: "Email",
    password: "Password",
    yourName: "Your full name",
    noAccount: "No account yet?",
    hasAccount: "Already have an account?",
    signUp: "Create account",
    signIn: "Sign in",
    toLogin: "To sign in",
    toRegister: "To sign up",
    treeTitle: "Village family tree",
    rootless: "Founding ancestors",
    emptyTree: "This tree is still empty. Start by adding a founding ancestor.",
    patriarch: "Patriarch/Matriarch",
    oralHistory: "Oral history",
    deleteSuccess: "Person removed",
    createSuccess: "Person added to the village",
    updateSuccess: "Information updated",
    addSpouse: "Add a spouse",
    removeSpouse: "Remove",
    noSpouses: "No spouse linked",
    to_verify: "To verify",
    testimony_confirmed: "Confirmed by testimony",
    cross_validated: "Cross-validated",
    recordAudio: "Record oral history",
    uploadAudio: "Upload audio",
    stopRecording: "Stop recording",
    recording: "Recording…",
    audioRecordings: "Oral recordings",
    audioTitle: "Recording title",
    noAudio: "No recordings yet",
    shareVillage: "Share the village",
    shareDesc: "Your whole family — wherever they are — can browse the tree from this link or by scanning the QR code.",
    copyLink: "Copy link",
    linkCopied: "Link copied ✓",
    suggestEdit: "Suggest a correction",
    suggestDesc: "Share a missing or corrected piece of information. A village contributor will validate it.",
    yourMessage: "Your message / correction",
    yourContact: "Your contact (optional)",
    sendSuggestion: "Send suggestion",
    suggestionSent: "Thank you! Your suggestion has been sent to contributors.",
    micDenied: "Microphone denied by browser",
    deleteAudio: "Delete this recording",
    suggestions: "Suggestions",
    openSuggestions: "Received suggestions",
    noSuggestions: "No suggestions yet.",
    markResolved: "Mark as resolved",
    resolved: "Resolved",
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang] = useState("fr");
  useEffect(() => { localStorage.setItem("ekom1_lang", "fr"); }, []);
  const t = (key) => translations["fr"]?.[key] ?? key;
  const toggle = () => {};
  return (
    <LangContext.Provider value={{ lang, setLang: () => {}, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
